<template>
  <div class="container-fluid pb-4 f14 color-black">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h2 class="mt-3">FORMAÇÃO ACADÊMICA</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CURSO</span>
        <span class="color-red font-weight-bold">*</span>
        <div>
          <VueSuggestion
            v-model="study_area.name"
            :selectedEl="study_area"
            :whenSelected="
              (item) => {
                study_area = item;
              }
            "
            classes="mt-1"
            placeholder="ENGENHEIRO, WEB DESIGNER, EDUCADOR, ETC..."
            responseDataName="study_areas"
            searchURL="/study_areas"
            style="text-transform: capitalize"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">CIDADE</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          :disabled="is_city_other_country"
          :focusOut="hasCity"
          :selectedEl="city"
          :whenSelected="setCity"
          classes="mt-1 mb-2"
          placeholder="SELECIONE UMA CIDADE"
          responseDataName="cities"
          searchURL="/cities"
        />
        <input
          v-model="is_city_other_country"
          :value="is_city_other_country"
          name="selectCandidate"
          type="checkbox"
        />
        <span class="font-weight-bold"> Exterior </span>
        <input
          v-if="is_city_other_country"
          v-model="city_other_country"
          :class="{ 'is-invalid': errors.city_other_country }"
          class="vs__input mt-2"
          placeholder="CIDADE"
          type="text"
          @focus="errors.city_other_country = false"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">INSTITUIÇÃO DE ENSINO</span>
        <span class="color-red font-weight-bold">*</span>
        <VueSuggestion
          v-model="institution.name"
          :selectedEl="institution"
          :whenSelected="
            (item) => {
              institution = item;
            }
          "
          classes="mt-1"
          placeholder="INSTITUIÇÃO QUE VOCÊ ESTUDOU..."
          responseDataName="institutions"
          searchURL="/institutions"
          style="text-transform: capitalize"
        />
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold">FORMAÇÃO</span>
        <span
          v-if="job.require_formation_type"
          class="color-red font-weight-bold"
        >
          *
        </span>
        <div
          class="select nav-tabs mt-1 p-0 block_info_white d-flex align-items-center"
        >
          <select v-model="formation" class="form-control">
            <option
              v-for="formation in formationsType"
              :key="formation.value"
              :value="formation.value"
            >
              {{ formation.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3 col-xs-12">
        <span
          :class="{ 'text-danger': errors.start_date }"
          class="font-weight-bold"
        >
          DATA DE INÍCIO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="start_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.start_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.start_date = false"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span
          :class="{ 'text-danger': errors.end_date }"
          class="font-weight-bold text-nowrap mt-2"
        >
          DATA DE TÉRMINO OU PREVISÃO DE TÉRMINO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="end_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.end_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.end_date = false"
          />
        </div>
        <div class="mt-2">
          <SwitchCheckbox
            v-model="studying_here"
            :value="studying_here"
            label="AINDA ESTUDA NESSA INSTITUIÇÃO?"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-6">
        <label class="font-weight-bold">
          SUA MÉDIA NA INSTITUIÇÃO (ESCALA DE 0 A 10)
        </label>
        <span
          v-if="job.require_average_point"
          class="color-red font-weight-bold"
        >
          *
        </span>
        <input
          v-model="average_point"
          :type="'text'"
          class="form-control"
          placeholder="0,0"
          @keydown="onAveragePointKeyDown($event)"
          @blur="onAveragePointBlur($event)"
        />
        <span class="f12 color-grey-primary to_uppercase">
          (Esse dado será checado posteriormente mediante pedido de histórico
          escolar)
        </span>
      </div>
      <div class="col-lg-6">
        <label class="font-weight-bold"> BOLSA DE ESTUDOS </label>
        <span v-if="job.require_scholarship" class="color-red font-weight-bold">
          *
        </span>
        <div class="row">
          <div class="col-lg-12">
            <input
              v-model="has_scholarship"
              :value="0"
              name="has_scholarship"
              style="vertical-align: super"
              type="radio"
            />
            <label class="mr-2"> Não se aplica </label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <input
              v-model="has_scholarship"
              :value="1"
              name="has_scholarship"
              type="radio"
            />
            <label class="mr-2"> Parcial </label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <input
              v-model="has_scholarship"
              :value="2"
              name="has_scholarship"
              type="radio"
            />
            <label class="mr-2"> Completa </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-lg-12 col-xs-12">
        <span class="font-weight-bold"
          >Comente sobre sua formação/bolsa, caso queira</span
        >
        <div class="mt-1">
          <textarea
            v-model="description"
            class="full form-control"
            cols="30"
            rows="10"
            style="height: 100px; border-radius: 5px"
            maxlength="610"
          ></textarea>
          <div class="d-flex justify-content-end">
            <small class="form-text text-muted"
              >{{ description.length }}/610</small
            >
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="createOrUpdate()"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import { format } from "date-fns";
import axios from "axios";
import SwitchCheckbox from "../../../../pages/Recruiters/Jobs/SwitchCheckbox.vue";

export default {
  props: ["education_id", "candidate_id", "account_uid", "job"],
  components: { VueSuggestion, SwitchCheckbox },
  mounted() {
    if (this.education_id) {
      let url = `/candidates/educations/${this.education_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/${this.education_id}`;
      }
      axios.get(url).then((response) => {
        let education = response.data.education;

        this.study_area.id = education.study_area_id;
        this.study_area.name = education.study_area_name.toLowerCase();
        this.institution.id = education.institution_id;
        this.institution.name = education.institution_name.toLowerCase();
        this.start_date = education.start_date
          ? format(new Date(education.start_date), "MM/yyyy")
          : "";
        this.end_date = education.end_date
          ? format(new Date(education.end_date), "MM/yyyy")
          : "";
        this.city.id = education.city_id;
        this.city.name = education.city_id
          ? education.city_name + " / " + education.state_uf
          : "";
        this.formation = education.formation_type;
        this.description = education.description;
        this.studying_here = education.studying_here;
        this.average_point = this.formatAveragePoint(education.average_point);
        this.has_scholarship = education.has_scholarship;
        this.is_city_other_country = education.city_other_country
          ? true
          : false;
        this.city_other_country = education.city_other_country || null;
      });
    }
  },
  data: () => ({
    start_date: "",
    end_date: "",
    description: "",
    studying_here: false,
    formation: 3,
    average_point: null,
    has_scholarship: null,
    is_city_other_country: false,
    city_other_country: null,
    institution: {
      id: 0,
      name: "",
    },
    study_area: {
      id: 0,
      name: "",
    },
    city: {
      id: 0,
      name: "",
    },
    formationsType: [
      { value: 0, text: "Colegial" },
      { value: 1, text: "Curso Técnico" },
      { value: 2, text: "Treinamento" },
      { value: 3, text: "Graduação" },
      { value: 4, text: "Iniciação Cientifica" },
      { value: 5, text: "Pós-Graduação" },
      { value: 6, text: "Mestrado" },
      { value: 7, text: "Doutorado" },
      { value: 8, text: "Phd" },
      { value: 9, text: "Outros" },
    ],
    errors: {
      start_date: false,
      end_date: false,
    },
  }),
  computed: {
    params() {
      let educations = {
        description: this.description,
        candidate_id: this.candidate_id,
        start_date: this.formatDate(this.start_date),
        end_date: this.formatDate(this.end_date),
        study_area: this.study_area.name.toLowerCase(),
        studying_here: this.studying_here,
        institution: this.institution.name.toLowerCase(),
        formation_type: this.formation,
        city_id: this.city.id === 0 ? null : this.city.id,
        average_point: this.average_point,
        has_scholarship: this.has_scholarship,
        city_other_country: this.city_other_country,
        account_id: this.account_uid,
      };
      return educations;
    },
  },
  methods: {
    onAveragePointKeyDown(event) {
      const el = event.target;
      const key = event.key;
      const currentValue = el.value;

      const isControlKey = [
        "Backspace",
        "Delete",
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ].includes(key);

      if (
        isControlKey ||
        ((event.ctrlKey || event.metaKey) &&
          ["a", "c", "v", "x", "z"].includes(key.toLowerCase()))
      ) {
        return;
      }

      const isDigit = /^[0-9]$/.test(key);
      const isDecimalSeparator = key === "." || key === ",";

      if (!isDigit && !isDecimalSeparator) {
        event.preventDefault();
        return;
      }

      if (isDecimalSeparator && currentValue.includes(".")) {
        event.preventDefault();
        return;
      }

      if (isDecimalSeparator && currentValue.includes(",")) {
        event.preventDefault();
        return;
      }

      const { selectionStart, selectionEnd } = el;
      const nextValueStr =
        currentValue.slice(0, selectionStart) +
        key.replace(",", ".") +
        currentValue.slice(selectionEnd);

      const parts = nextValueStr.split(".");
      if (parts.length > 1 && parts[1] && parts[1].length > 1) {
        event.preventDefault();
        return;
      }

      if (nextValueStr !== "." && nextValueStr !== "") {
        const nextNum = parseFloat(nextValueStr);
        if (!isNaN(nextNum) && nextNum > 10) {
          event.preventDefault();
          return;
        }
      }
    },
    onAveragePointBlur(event) {
      let value = event.target.value.replace(/,/g, ".");
      if (value === "" || value === ".") {
        this.average_point = null;
        return;
      }

      const num = parseFloat(value);
      if (isNaN(num)) {
        this.average_point = null;
        return;
      }

      const limited = Math.min(num, 10);
      const rounded = Math.round(limited * 10) / 10;
      this.average_point = rounded;
    },
    formatAveragePoint(value) {
      if (value === null || value === undefined || value === "") return null;
      const numberValue = parseFloat(String(value).replace(",", "."));
      if (isNaN(numberValue)) return null;
      return Math.round(numberValue * 10) / 10;
    },
    setCity(event) {
      this.city.id = event.id;
      this.city.name = event.title;
      this.city_other_country = null;
    },
    createOrUpdate() {
      if (!this.validForm()) return;
      if (!this.validDate(this.start_date, "start_date")) return;
      if (!this.validDate(this.end_date, "end_date")) return;

      if (this.education_id) {
        this.updateExperience();
        return;
      }

      this.createExperience();
    },
    createExperience() {
      let url = `/candidates/educations/`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/`;
      }
      axios
        .post(url, {
          educations: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    updateExperience() {
      let url = `/candidates/educations/${this.education_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/educations/${this.education_id}`;
      }
      axios
        .put(url, {
          educations: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    sendFeedback(status) {
      if (!status) {
        this.$toast.error("Sinto muito, não foi possivel salvar.");
        return;
      }

      this.$toast.success("Formação acadêmica salva com sucesso!");
      eventBus.$emit("getEducations");
      eventBus.$emit("updateInfo");
      this.$modal.hideAll();
    },
    validForm() {
      let fields = [
        { name: "Curso", value: this.study_area.name },
        { name: "Instituição de ensino", value: this.institution.name },
        { name: "Ano de inicio", value: this.start_date },
        { name: "Ano de término", value: this.end_date },
      ];

      if (this.city_id === 0) this.city_id = null;

      if (!this.city.id && !this.is_city_other_country) {
        this.$toast.error(`O campo "Cidade" não pode ficar vazio.`);
        return false;
      }

      if (this.average_point < 0 || this.average_point > 10) {
        this.$toast.error(`O campo Média deve ser um número entre 0 e 10.`);
        return false;
      }

      if (this.is_city_other_country && !this.city_other_country) {
        this.$toast.error(`O campo "Cidade" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_formation_type &&
        this.formation !== 0 &&
        !this.formation
      ) {
        this.$toast.error(`O campo "Tipo de formação" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_scholarship &&
        this.has_scholarship !== 0 &&
        !this.has_scholarship
      ) {
        this.$toast.error(`O campo "Bolsas de estudos" não pode ficar vazio.`);
        return false;
      }

      if (
        this.job.require_average_point &&
        !this.average_point &&
        this.average_point !== 0
      ) {
        this.$toast.error(
          `O campo "Média na instituição" não pode ficar vazio.`
        );
        return false;
      }

      for (let field of fields) {
        if (field.value.length === 0) {
          this.$toast.error(`O campo "${field.name}" não pode ficar vazio.`);
          return false;
        }
      }

      return true;
    },
    validDate(dateStr, field) {
      if (!dateStr || dateStr.length === 0) {
        this.$toast.error("Por favor, preencha o campo corretamente.");
        this.errors[field] = true;
        return false;
      }

      if (dateStr.indexOf("/") === -1) {
        this.$toast.error("Formato de data inválido. Use MM/YYYY.");
        this.errors[field] = true;
        return false;
      }

      let month = parseInt(dateStr.slice(0, dateStr.indexOf("/")));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      if (field === "start_date") {
        const start_date = new Date(year, month - 1, "01");
        const today = new Date();
        if (start_date > today) {
          this.errors[field] = true;
          return false;
        }
      }

      if (month === 0 || month > 12) {
        this.$toast.error("Data invalida.");
        this.errors[field] = true;
        return false;
      }

      if (year <= 1960 || year >= 2050) {
        this.$toast.error("Data invalida, insira um ano valido.");
        this.errors[field] = true;
        return false;
      }

      return true;
    },
    formatDate(dateStr) {
      let month = dateStr.slice(0, dateStr.indexOf("/"));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      return year.concat("/", month, "/01");
    },
    hasCity(event, items, select) {
      if (select) {
        this.city.id = select.id;
        this.city.name = select.name;
      } else {
        this.city = items[0] ? items[0] : { id: 0, name: "" };
      }
      if (!this.city)
        this.$toast.error("Por favor, informe a cidade de candidato(a).");
    },
  },
};
</script>

<style>
@media (max-width: 768px) {
  .vm--modal {
    top: 80px !important;
    left: 0 !important;
    max-height: 70vh;
    overflow-y: auto !important;
    width: 90vw !important;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
